import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { testparams, months, fieldName, paramNames } from "./ChartConstants";
import SingleChart from "../../shared/charts/SingleChart";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import Checkbox from "@material-ui/core/Checkbox";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import * as  FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { LOADING } from "../../action";
import { postRequest } from "../../services/ApiServices";
import moment from 'moment';
import Button from '@mui/material/Button';
import { useDispatch } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CancelIcon from '@mui/icons-material/Cancel';

const useStyles = makeStyles((theme) => ({
    heading: {
        color: "#ff4717",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },  
    theadingstyles: {
        background: "rgb(26 26 49)",
        padding: "12px",
        borderTopRightRadius: "10px",
        borderTopLeftRadius: "10px",
        color: "white",
        fontSize: "16px",
    },
}));

export default function Chart(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {chartParameters, selectedShip,formObj} = props;
    const title = chartParameters.title;
    const testParameter = chartParameters.field
    const [chartData, setChartData] = React.useState([]);
    const [chartResData, setChartResData] = React.useState([]);
    const [chartTestParameter, setChartTestParameter] =React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [showchart, setShowChart] = React.useState([]);
    const [allTheCheckBoxKeysForChecked, setAllTheCheckBoxKeysForChecked] = useState(testparams);
    
    React.useEffect(() => {
            if(!selectedShip.length){
                clearChart();
            }
            
            if(chartTestParameter.length){
                getChartData(chartTestParameter)
            }
            
    },[selectedShip])

    const exportToExcel = async (excelDate, fileName) => {
        excelDate.forEach((d) => {
            d.name = d.name + " ( " + d.imoNumber + " ) ";
            if (d.dataEntryDt) {
                d.ReportDate = moment(d.dataEntryDt).format('DD-MM-YYYY');

            }
            delete d.imoNumber
            delete d.dataEntryDt
            delete d.pdfFileName
        })
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(excelDate);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    const handleClickFileDownload = (chartType) => {
        exportToExcel(chartResData, title)
        
    };

    const handleClickOpen = (chartType) => {       
        setShowChart(chartData);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const selectedTestParameter = (event) => {
        let checkedList = chartTestParameter;
        var isChecked = event.target.checked;
        
        if (isChecked) {
            checkedList.push(event.target.name);
        } else {
            let testparametersIndex = checkedList.indexOf(event.target.name);
            checkedList.splice(testparametersIndex, 1);
        }
        setChartTestParameter(checkedList);
   
        if (checkedList.length) {
            getChartData( checkedList);

        } else {
            setChartData([]);
        }
    };

    function getData(x) {
        var shipsName = [];
        x.forEach((rec) => {
            shipsName.push(rec.name);
        });
        shipsName = [...new Set(shipsName)];
        var testParms = [];
        x.forEach((rec) => {
            testParms.push(rec.testParameter);
        });
        testParms = [...new Set(testParms)];
        var uDate = [];
        x.forEach((rec) => {
            uDate.push(new Date(rec.dataEntryDt));
        });
        
        uDate = [...new Map(uDate.map(item => [JSON.stringify(item), item])).values()];
        uDate.sort((a, b,) => a.valueOf() - b.valueOf());
        
        var xAxis = [];
        xAxis.push("X");
        shipsName.forEach((tn) => {
            testParms.forEach((tp) => {
                let itemName = tn + ' - ' + tp;
                if (typeof tp != "undefined") {
                    xAxis.push({ label: itemName, type: 'number' });
                    xAxis.push({ role: "tooltip", type: "string", p: { html: true } });
                }
            });
        });

        
        var yAxis = [];

        for (var v = 0; v < uDate.length; v++) {
            var yr = [];
            yr.push(uDate[v]);
            for (var k = 0; k < shipsName.length; k++) {
                for (var u = 0; u < testParms.length; u++) {
                    yr.push(null);
                    yr.push(null);
                }
            }
            yAxis.push(yr);
        }
        for (var i = 0; i < yAxis.length; i++) {
            let row = yAxis[i];
            for (var w = 0; w < x.length; w++) {
                var rec = x[w];
                let mont = new Date(rec.dataEntryDt).getDate() + '-' + months[new Date(rec.dataEntryDt).getMonth()] + '-' + new Date(rec.dataEntryDt).getFullYear();
                let itemName = rec.name + ' - ' + rec.testParameter;
                let indexPara = xAxis.findIndex(obj => obj.label == itemName);
                if (row[0].getTime() === new Date(rec.dataEntryDt).getTime()) {      
                    yAxis[i][indexPara] = rec.testCountcss;
                    let tooltip = "";
                    tooltip += "Asset: " + itemName + "<br>";
                    tooltip += "Value: " + rec.testCountcss + "<br>";
                    tooltip += "Date: " + mont + "<br>";
                    tooltip += "Sample No: " + rec.sampleControlNoCd;
                    yAxis[i][indexPara + 1] = tooltip;
                    
                }
            }
        }
        return [xAxis, ...yAxis];
    }

    const getChartData = (TestParameter) => {
        dispatch({ type: LOADING, payload: true });
        let filterValidObj = {};
        var tarKeys = []; 
        selectedShip.forEach((obj) => { tarKeys.push(obj.shipId) });
        filterValidObj = { ...filterValidObj, vesselKey: tarKeys.join() }
        filterValidObj = { ...filterValidObj, testParameter: TestParameter.join() }
        const url =
            process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Trend/Vessels_Fuel/Filter`;
        
        postRequest(url, filterValidObj)
            .then((res) => {
                res.data.forEach((d) => {
                    d.dataEntryDt = moment(d.dataEntryDt).format('YYYY/MM/DD');
                })
                let data = [];
                data = res.data.filter((value) => value.dataEntryDt > formObj.startDate && value.dataEntryDt < formObj.endDate)
                res.data=data;
                let result = getData(res.data);
                    if (result.length) {
                        setChartData(result);
                        setChartResData(res.data);
                    } else {
                        setChartData([]);
                    }
                dispatch({ type: LOADING, payload: false });
            })
            .catch((error) => {
                dispatch({ type: LOADING, payload: false });
            });
    };
    
    const clearChart = () =>{
        setAllTheCheckBoxKeysForChecked(testparams);
        setChartData([])
        setChartResData([])
        setChartTestParameter([]);
    }    

    return (
        <Grid item xs={12} md={6} className="trendschart">
            <Dialog
                fullWidth={fullWidth}
                maxWidth="xl"
                fullScreen={true}
                open={open}
                onClose={handleClose}
            >
                <DialogActions>
                    <Button onClick={handleClose}><CancelIcon /></Button>
                </DialogActions>

                <DialogContent>
                    <SingleChart chartData={showchart} />
                </DialogContent>

            </Dialog>

            <Typography
                variant="h5"
                align="left"
                className={clsx(classes.heading, classes.theadingstyles)}
            >
                <div>
                    {title}

                    {chartData.length > 1 ? (
                        <button style={{ float: "right", padding: "0px" }} onClick={() => handleClickFileDownload()}>
                            <FileDownloadIcon />
                        </button>
                    ) : ""}

                    {chartData.length > 1 ? (
                        <button style={{ float: "right", padding: "0px" }} onClick={() => handleClickOpen()}>
                            <ZoomOutMapIcon />
                        </button>
                    ) : ""}
                </div>
            </Typography>

            <Paper
                className={classes.paper + " scrollBar"}
                style={{ height: "400px", overflow: "auto" }}
            >
                <Grid container spacing={2} style={{ textAlign: "left" }} >
                    {testParameter.map((item)=>{
                        return(
                            <Grid item >
                                <Box component="">
                                    <Checkbox
                                        name={paramNames(item)}
                                        value={item}
                                        label={item}
                                        onClick={(event) => {
                                            setAllTheCheckBoxKeysForChecked({ ...allTheCheckBoxKeysForChecked, [item]: event.target.checked });
                                            selectedTestParameter(event);
                                        }}
                                        checked={allTheCheckBoxKeysForChecked[item]}
                                        className={clsx(classes.MuiButtonBaseRoot)}
                                        checkedIcon={
                                            <StopSharpIcon
                                                className={clsx(classes.MuiSvgIconRoot)}
                                            />
                                        }
                                        inputProps={{ "aria-label": "Checkbox A" }}
                                    />
                                    <Box component="span" pl={1}>
                                        {
                                        fieldName(item)
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                        )
                    })}    
                </Grid>
                {chartData.length > 1 ? (
                    <div>
                        <SingleChart chartData={chartData} />
                    </div>
                    ) : (
                        chartData.length == 1 ? (
                            <Box py={4} fontWeight="bold" >No Records found</Box>
                        ) : (
                            <React.Fragment>
                                {selectedShip.length == 0 ? (
                                    <Box py={4} fontWeight="bold" >Please select Ship key</Box>
                                ) :  selectedShip.length > 0 ? (<Box py={4} fontWeight="bold" >Please select test parameters</Box>)
                                    : (<Box py={4} fontWeight="bold" ></Box>)}
                            </React.Fragment>
                        )
                    )
                }
            </Paper>
        </Grid>
    );
}